/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Footer_NavigationInputs */

const en_gc_home_footer_navigation = /** @type {(inputs: Gc_Home_Footer_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources and project links`)
};

const zh_gc_home_footer_navigation = /** @type {(inputs: Gc_Home_Footer_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资源和项目链接`)
};

/**
* | output |
* | --- |
* | "Resources and project links" |
*
* @param {Gc_Home_Footer_NavigationInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_footer_navigation = /** @type {((inputs?: Gc_Home_Footer_NavigationInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Footer_NavigationInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_footer_navigation(inputs)
	return zh_gc_home_footer_navigation(inputs)
});
export { gc_home_footer_navigation as "gc.home.footer_navigation" }